import { HomeIcon } from '@heroicons/react/24/solid';
import { Link } from '@remix-run/react';
import { useTranslation } from 'react-i18next';

export function Breadcrumbs({
  items,
}: {
  items: { name: string; slug: string; id: string }[];
}) {
  const { t } = useTranslation();

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol role="list" className="flex items-center space-x-1 md:space-x-2">
        <li>
          <div>
            <Link
              to="/"
              className="hover:text-[#E80245] transition-colors"
              style={{
                fontFamily: 'Poppins, sans-serif',
                fontSize: '13px',
                lineHeight: '16px',
                fontWeight: 400,
                color: '#54454A'
              }}
            >
              Home
            </Link>
          </div>
        </li>
        {items
          .filter((item) => item.name !== '__root_collection__')
          .map((item, index) => (
            <li key={item.name}>
              <div className="flex items-center">
                <span
                  className="mx-2"
                  style={{
                    fontSize: '13px',
                    lineHeight: '16px',
                    color: '#54454A'
                  }}
                >{'>'}</span>
                <Link
                  to={`/collections/${item.slug}`}
                  className="hover:text-[#E80245] transition-colors"
                  style={{
                    fontFamily: 'Poppins, sans-serif',
                    fontSize: '13px',
                    lineHeight: '16px',
                    fontWeight: 400,
                    color: '#54454A'
                  }}
                >
                  {item.name}
                </Link>
              </div>
            </li>
          ))}
      </ol>
    </nav>
  );
}
